export default __webpack_public_path__ + "static/media/icon-close.cad3752c.svg";